import React from "react";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../commons/filters/FilterChip.js";
import { isTagReserved, useReservedTagLabels } from "./useReservedTagLabels.js";

type FilterCrmTagChipGroupProps = Omit<
  FilterChipGroupProps<string>,
  "getValueLabel"
>;

export const FilterCrmTagChipGroup = (props: FilterCrmTagChipGroupProps) => {
  const { reservedTagLabels } = useReservedTagLabels();

  const getValueLabel = (value: string) => {
    return isTagReserved(value) ? reservedTagLabels[value] : value;
  };

  return <FilterChipGroup {...props} getValueLabel={getValueLabel} />;
};
